import repository from '@/repositories/Repository'
import { setCache, generateCacheKey, getCache } from '@/util/cache'

const resource = '/item_categories'

export default {
  async get(company, posRestriction) {
    // キーにはAPIリクエストにかかるパラメータを含める
    const _cacheKey = generateCacheKey(resource, company, posRestriction)
    const cacheData = await getCache(_cacheKey)
    if (cacheData) {
      return cacheData
    }
    const url = !posRestriction
      ? `${resource}/${company}`
      : `${resource}/${company}?dataType=POS`

    const data = await repository.bizoo.get(url).then(r => {
      setCache(_cacheKey, r.data)
      return r.data
    })
    return data
  },
  getDrilldownData(
    company,
    fromItemCategoryLevel,
    toItemCategoryLevel,
    itemCategories,
  ) {
    const queryParams = {
      itemCategories: itemCategories.join(','),
      fromItemCategoryLevel,
      toItemCategoryLevel,
    }

    const queryParamsStr = Object.entries(queryParams)
      .filter(entry => entry[1] !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    return repository.bizoo
      .get(`${resource}/${company}/drilldown?${queryParamsStr}`)
      .then(r => r.data)
  },
}
